import { CSSProperties } from 'react';
import { Row } from 'react-table';

import { AlignText } from 'coreOld/enums';

import { Td, Tr } from './bodyStyles';

interface IProps {
  onRowClick;
  rows: Row<object>[];
  prepareRow: (row: Row<object>) => void;
  borderBottom?: boolean;
  borderRight?: boolean;
  alternating?: boolean;
  tableBodyStyle?: CSSProperties;
  textAlign: AlignText;
}

const Body = ({
  rows,
  prepareRow,
  borderBottom,
  borderRight,
  alternating,
  onRowClick,
  tableBodyStyle,
  textAlign = AlignText.RIGHT,
}: IProps) => {
  return (
    <>
      {rows.map((row, index) => {
        prepareRow(row);

        const isEven = (index: number) => alternating && index % 2 === 0;
        const isOdd = (index: number) => alternating && (index + 1) % 2 === 0;

        return (
          <Tr
            {...row.getRowProps()}
            key={index}
            isEven={isEven(row.index)}
            isOdd={isOdd(row.index)}
            isRowSelected={row.isSelected}
            borderBottom={borderBottom}
            onClick={() => typeof onRowClick === 'function' && onRowClick(row.original)}
          >
            {row.cells.map((cell, index) => (
              <Td
                key={index}
                isRowSelected={row.isSelected}
                borderRight={borderRight}
                textAlign={textAlign}
                {...{
                  ...cell.getCellProps({
                    style: {
                      width: cell.column.width,
                      minWidth: cell.column.minWidth,
                      ...tableBodyStyle,
                    },
                  }),
                }}
              >
                {cell.render('Cell')}
              </Td>
            ))}
          </Tr>
        );
      })}
    </>
  );
};

export default Body;
